import styled from 'styled-components';
import color from '@deprecated-ui/_style/color';

const ContainerResult = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ResultPaginationInfo = styled.div`
  position: relative;
  display: block;
  font-size: 14px;
  font-family: var(--font-regular);
  color: ${color.highempahis};
`;

export {
  ContainerResult,
  ResultPaginationInfo,
};
